<lib-ui-sidebar [logo]="logo" [navigation]="navigation">
  <router-outlet />
</lib-ui-sidebar>
